import type { NotificationRecord } from "./types"

// Every record states its `placement`: `home` — drawn on the home screens only,
// `app` — over any screen, `null` — the notification shows nothing in the app.

export type PushTapAction = "raise" | "dismiss"

/** Whether the overlay may draw this record on the current screen. */
export function isShownOnScreen(
	record: NotificationRecord,
	onHomeScreen: boolean,
): boolean {
	switch (record.placement) {
		case null:
			return false
		case "app":
			return true
		case "home":
			return onHomeScreen
	}
}

/**
 * What a push tap does to its record: a home popup is raised when the tap
 * leads home and dismissed elsewhere; a popup drawn over any screen gives
 * way to what the push opened.
 */
export function pushTapActionOf(
	record: NotificationRecord,
	onHomeScreen: boolean,
): PushTapAction {
	switch (record.placement) {
		case "app":
			return "dismiss"
		case null:
		case "home":
			if (onHomeScreen) return "raise"
			return "dismiss"
	}
}
